import React from 'react';

import { cn } from '@change/ds-utils';

import { Card, CardBody, CardHeader } from '@change/ds-core-ui/next';

import { type Platform, PLATFORM_CONFIG } from '../../../../../shared/constants';

/**
 * Platform card skeleton component for displaying loading state with platform-specific badge.
 */
export const PlatformCardSkeleton: React.FC<Props> = ({ platform, placeholderColor }) => {
	const { Icon, bgColor, iconColor } = PLATFORM_CONFIG[platform];

	return (
		<div
			data-platform={platform}
			data-testid={`placeholder-social-card-${platform}`}
			className="relative snap-center"
			aria-hidden="true"
		>
			<div
				className="absolute -right-[3px] -top-[3px] z-10 flex h-8 w-8 items-center justify-center rounded-full border border-solid border-white"
				style={{ backgroundColor: bgColor }}
				data-testid={`${platform}-icon-badge`}
			>
				<Icon className={iconColor} size={20} />
			</div>

			<Card
				className="elevation-low flex h-full max-h-[160px] flex-col rounded-xl border-[1.5px] bg-white [--card-gap:0px] orientation-vertical:w-[125px]"
				orientation="vertical"
			>
				<>
					<CardHeader variant="media" className="h-[104px]">
						<div
							className={cn(
								'h-min-[104px] flex h-full w-full animate-pulse items-center justify-center',
								placeholderColor,
							)}
						/>
					</CardHeader>

					<CardBody className="flex flex-col gap-1.5 px-3 pt-3">
						<div className={cn('h-[18px] w-full animate-pulse rounded', placeholderColor)} />
						<div className={cn('h-[14px] w-4/5 animate-pulse rounded', placeholderColor)} />
					</CardBody>
				</>
			</Card>
		</div>
	);
};

type Props = Readonly<{
	platform: Platform;
	placeholderColor: string;
}>;
